import React from "react";
import { ChartTooltipProvider } from "./ChartTooltipArea";
import type { TooltipWrapperProps } from "./types";

export const ChartTooltipWrapper = <T extends object>({
  component: Component,
  ...props
}: TooltipWrapperProps<T>) => {
  return (
    <ChartTooltipProvider>
      <Component {...props} />
    </ChartTooltipProvider>
  );
};
